import * as React from 'react';
import * as ReactDom from 'react-dom';
import { useEffect, useState } from 'react';

//import { graph } from '@pnp/graph';
//import { MSGraphClient } from '@microsoft/sp-http';
//import { WebPartContext } from "@microsoft/sp-webpart-base";

import { escape } from '@microsoft/sp-lodash-subset';
import * as Fabric from 'office-ui-fabric-react';
import { Link, initializeIcons, ActivityItem, Icon } from 'office-ui-fabric-react';
import { CommandBar, ICommandBarItemProps } from 'office-ui-fabric-react/lib/CommandBar';
import { DirectionalHint } from 'office-ui-fabric-react/lib/Callout';
import { ChannelsContainer } from '../channel/ChannelsContainer';
import  * as uuidv4 from "uuid/v4";
import log from 'loglevel';
import { teamStyle, classNames } from "./Team.Styles";

export const Team = ({ teamID, team, accessToken}) => {

  const [showChannels, setShowChannels] = useState(false);  
  log.info(`Team`);

  const toggleShowChannels = ()=>{
    log.info(`toggleShowChannels @ Team`);
        setShowChannels(!showChannels);
  };
  

  // Initialize icons in case this example uses them
  initializeIcons();

  const activityItemExamples = [
    {
      key: 1,
      activityDescription: [
        <span key={1}>{`[Team:] ${team.displayName}`} </span>,
        <Link
          key={1}
          className={classNames.nameText}
          href={team.webUrl}
        > 
           <Icon iconName={''} />
           <Icon iconName={'Message'} /> Teams
        </Link>,
        <Link
        key={2}
        
        className={classNames.nameText}
        onClick={() => {
          toggleShowChannels();
        }}
      > 
         <Icon iconName={''} />
         <Icon iconName={'Message'} /> Channels
      </Link>

      ],
      activityIcon: <Icon iconName={'Message'} />
    }
  ];


      const handleTeamWebUrl = ()=>{
        log.info(`handleTeamWebUrl @ Team`);
        //window.open(team.webUrl, '_blank')
      }

        const _items = [
      {
        key: 'open',
        iconProps: { iconName: 'TeamFavorite' }
        // onClick: () => {
        //   handleTeamWebUrl(); // needs further exploration to get the actual url
        // }
      },
      {
        key: 'share',
        text: `[Team:] ${team.displayName}`,
       // onClick: () => {handleClick()}
      }

    ];

    const _farItems = [
     
      {
        key: 'showChannels',
        text: 'Show channels',
        iconOnly: true,
        iconProps: { iconName: 'DrillExpand' },
        onClick:  ()=>{ toggleShowChannels(); } 
      }
  
    ];
    
    const renderTeamBar=()=>{
      log.info(`renderTeamBar @ Team`);
      return (
              <div style={teamStyle()} >
              
              <CommandBar
                      items={_items}
                      farItems={_farItems}
                    />
              </div>
              );  
    };

   const renderChannels = ( accessToken ) => {
      log.info(`renderChannels @ Team`);
       return (
                showChannels ? <ChannelsContainer 
                            teamId =  { teamID } 
                            accessToken = { accessToken }
                            /> : '' 
              )       
   }
  
    return (
    <>
      {renderTeamBar()}
      {renderChannels( accessToken )} 
    </>
  )

}





/**
 * 
 * 
 *      <ul>
        {channelsList.map(channel => {
          return (
              <li key={create_UUID()}>
                <a  key={create_UUID()} href={channel.webUrl}>{channel.displayName}</a>
              </li>
          );
        })}
      </ul>
 
 * 
 * 
 */
/*

 <Channel
                key={create_UUID()}
                teamId = {teamID}
                channelId = {channel.id}
                channelDisplayName = {channel.displayName}
                context = {context}
              ></Channel>

*/ 



 //const [channelsList, setChannelsList] = useState([]);
  //"Accept": 'application/json;odata=nometadata'
 
  // React.useEffect(() => {
  //   // if (true)
  //   //         graph.teams.getById(teamID).channels.get().then(channels => { 
  //   //         setChannelsList(channels);      
  //   //   });
  //   if (showChannels)
  //   {
  //       getChannels(teamID,context).then((teamChannels) =>{
  //         //setChannelsList([...teamChannels]);
  //       }); 

  //   }
  //   else
  //           setChannelsList([]);
  // }, [showChannels]);

  // const getChannels = async (teamId, context) =>{
  //   console.log(`@getChannels >  teamId - ${teamId}`);
  //   const channelsUrl = `/teams/${teamId}/channels`;///${channelId}/messages`; //MESSAGES_URL;
     
  //   context.msGraphClientFactory
  //   .getClient()
  //   .then((client: MSGraphClient)=> {
  //           client
  //           .api(channelsUrl)
  //           .headers({
  //             "Content-Type" : "application/json;charset=UTF-8",
  //              "mode": "cors",
  //             "Access-Control-Allow-Origin" : '' 
  //           })
  //           .version('beta')
  //           .get().then((response) => {


  //                                       console.log('@getChannels >  teamChannels ' + JSON.stringify(response));
                                          
  //                                       const  selectedChannels =   response.value.map(teamChannel => {
  //                                         const _teamChannel = 
  //                                           {
  //                                              id :  teamChannel.id,
  //                                              webUrl : teamChannel.webUrl,
  //                                              displayName : teamChannel.displayName
  //                                           };
                                            
  //                                           return _teamChannel;
  //                                       });

  //                                        console.log('@getChannels >  selectedChannels ' + JSON.stringify(selectedChannels));
                                
  //                                       setChannelsList(selectedChannels); 

  //                                       }
  //               //)
  //             );
  //           }
  //   );

  // };



          {/* <TextField
          key={uuidv4()}
          value={`[Team:] ${displayName}`}
          readOnly
          resizable={false}  
          onClick={ ()=>{ toggleShowChannels(); } }
          style={teamStyle()}
        /> */}
        


        // const teamStyle = () => {
//     const _style =
//       {
//             textDecoration: "",
//             color: "black",
//             backgroundColor: "#a19f9d"
//       };
//     return _style;
//   };



  // const renderTeam = () =>{
    //     const _team = activityItemExamples.map((item: { key: string | number }) => (
    //             <ActivityItem {...item} key={item.key} className={classNames.exampleRoot} />
    //     ))
    //     return _team;
    // }
